import React from 'react';
import imgResolver from '../utils/img-resolver';
import LoadingView from '../components/LoadingView';
import RatePeopleInfo from '../components/RatePeopleInfo';

import HiringStore from '../stores/HiringStore';

import connectToStores from 'alt/utils/connectToStores';

@connectToStores
class FinishShiftStep1 extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            blockedCandidates: [],
            likedCandidates: [],
            noShowCandidates: [],
            candidatesReceived: false
        };
    }

    componentWillReceiveProps(nextProps) {
       if (!this.state.candidatesReceived && nextProps.candidates != null) {
           const blockedCandidates = [];
           const likedCandidates = [];
           const noShowCandidates = [];
           nextProps.candidates.forEach(candidate => {
               if (candidate.hiring.no_show) {
                   noShowCandidates.push(candidate.id);
               }
               if (candidate.hiring.like) {
                   likedCandidates.push(candidate.id);
               }
               if (candidate.hiring.banned) {
                   blockedCandidates.push(candidate.id);
               }
           });

           this.setState({blockedCandidates, likedCandidates, noShowCandidates, candidatesReceived: true});
       }
    }

    static getPropsFromStores() {
        return {
            hStore: HiringStore.getState()
        };
    }

    static getStores() {
        return [HiringStore];
    }

    getProfilePicture(profile_picture, id) {
        if (profile_picture) {
            return <img width={40} height={40} className={"candidate-header-avatar " + (this.state.blockedCandidates.indexOf(id) > -1 ? "banned" : "")} src={profile_picture} alt=""/>;
        } else {
            return <img width={40} height={40} className={"candidate-header-avatar " + (this.state.blockedCandidates.indexOf(id) > -1 ? "banned" : "")} src={require('../styles/images/team_member.png')} alt=""/>
        }
    }

    likeBlockCandidate(actionType, id) {
        let candidates = actionType == 'like' ? this.state.likedCandidates : actionType == 'no-show' ? this.state.noShowCandidates : this.state.blockedCandidates;
        let oppositeCandidates = actionType == 'like' ? {0: this.state.blockedCandidates, 1: this.state.noShowCandidates} : {0: this.state.likedCandidates};
        const index = candidates.indexOf(id);
        if (index > -1) {
            candidates.splice(index, 1);
        } else {
            candidates.push(id);
            for (let i=0; i<Object.keys(oppositeCandidates).length; i++) {
                const oppositeIndex = oppositeCandidates[i].indexOf(id);
                if (oppositeIndex > -1) {
                    oppositeCandidates[i].splice(oppositeIndex, 1);
                }
            }
        }

        this.setState({state: candidates});
    }

    getCandidates() {
        let hired_candidates = [];

        this.props.candidates.forEach(candidate => {
            hired_candidates.push(
                <div className="rate-person">
                    <div className="col col-1">
                        <div className="flag">
                            <div className="flag-left">
                                {this.getProfilePicture(candidate.user.profile_picture, candidate.id)}
                            </div>

                            <div className="body">
                                <span className={"person-name " + (this.state.blockedCandidates.indexOf(candidate.id) > -1 ? "banned" : "")}>{candidate.user.first_name + ' ' + candidate.user.last_name}</span>
                            </div>
                        </div>
                    </div>

                    <div className="col col-2">
                        <button onClick={this.likeBlockCandidate.bind(this, 'block', candidate.id)} className={"btn-block " + (this.state.blockedCandidates.indexOf(candidate.id) > -1 ? "btn-block-gray" : "")}>BAN</button>
                        <button onClick={this.likeBlockCandidate.bind(this, 'like', candidate.id)} className={"btn-like " + (this.state.likedCandidates.indexOf(candidate.id) > -1 ? "btn-like-green" : "")}>LIKE</button>
                        <button onClick={this.likeBlockCandidate.bind(this, 'no-show', candidate.id)} className={"btn-no-show " + (this.state.noShowCandidates.indexOf(candidate.id) > -1 ? "btn-no-show-orange" : "")}>NO-SHOW</button>
                    </div>
                </div>
            );
        });

        return hired_candidates;
    }

    saveState() {
        HiringStore.likeCandidates(
            this.props.shiftId, this.state.likedCandidates, this.state.noShowCandidates, this.state.blockedCandidates
        );
        this.props.nextHeader();
    }

    getContent() {
        return (
            <div>
                <RatePeopleInfo />

                <div className="rate-people">
                    {this.getCandidates()}
                </div>
                <button onClick={this.saveState.bind(this)} className="btn btn-green btn-small btn-continue">Continue</button>
            </div>
        );
    }

    render () {
        return (
            <div className={"finish-shift-step-content finish-shift-step1 " + this.props.className}>
                {this.state.candidatesReceived ? this.getContent() : <LoadingView />}
            </div>
        );
    }
}

export default FinishShiftStep1;



/** WEBPACK FOOTER **
 ** ./app/src/components/FinishShiftStep1.js
 **/